import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Tracks unsaved configurator edits by comparing against the baseline snapshot.
 */
export function useConfiguratorDirtyState(config) {
  const [isDirty, setIsDirty] = useState(false);
  const baselineRef = useRef('');
  const initializedRef = useRef(false);

  useEffect(() => {
    const serialized = JSON.stringify(config);
    if (!initializedRef.current) {
      baselineRef.current = serialized;
      initializedRef.current = true;
      return;
    }
    setIsDirty(serialized !== baselineRef.current);
  }, [config]);

  const markClean = useCallback(() => {
    baselineRef.current = JSON.stringify(config);
    setIsDirty(false);
  }, [config]);

  const markDirty = useCallback(() => {
    setIsDirty(true);
  }, []);

  const resetBaseline = useCallback((nextConfig) => {
    baselineRef.current = JSON.stringify(nextConfig);
    setIsDirty(false);
  }, []);

  return { isDirty, markClean, markDirty, resetBaseline };
}
